import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";

const RequireLogout = (Component) => {
  const LogoutComponent = (props) => {
    const navigate = useNavigate();
    const token = Cookies.get("hippocratic_portal_token");

    useEffect(() => {
      if (token) {
        navigate("/Overview");
      }
    }, [token, navigate]);

    if (token) {
      return null;
    } else {
      return <Component {...props} />;
    }
  };

  return LogoutComponent;
};

export default RequireLogout;
